var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavAirspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0243 22.6634C14.8122 23.0927 15.1327 23.5233 15.2177 23.8069C15.2802 24.0153 15.2636 24.3069 14.8732 24.7058C14.4585 25.1296 13.7103 25.561 12.641 25.8808C11.5864 26.1964 10.3374 26.3676 9.04876 26.3627C7.75994 26.3577 6.51825 26.1769 5.47691 25.854C4.4203 25.5264 3.69356 25.0915 3.2999 24.6714C2.9345 24.2815 2.92387 23.9979 2.99579 23.7832C3.09433 23.4891 3.43956 23.0542 4.24643 22.6287",
    stroke: "#BBC2CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.118 9.37785C17.118 15.7954 9.87318 21.7389 9.87318 21.7389C9.44985 22.0863 8.75705 22.0863 8.33373 21.7389C8.33373 21.7389 1.08887 15.7954 1.08887 9.37785C1.08895 4.95151 4.67718 1.36328 9.10347 1.36328C13.5298 1.36328 17.118 4.95151 17.118 9.37785Z",
    stroke: "#BBC2CF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10246 12.4101C7.43138 12.4101 6.07031 11.049 6.07031 9.37794C6.07031 7.70689 7.43147 6.3457 9.10246 6.3457C10.7735 6.3457 12.1346 7.70684 12.1346 9.37785C12.1346 11.0489 10.7735 12.4101 9.10246 12.4101Z",
    stroke: "#BBC2CF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAirspace);
export default __webpack_public_path__ + "static/media/nav-airspace.8bc6693adaa709813bbbe0953c5b190c.svg";
export { ForwardRef as ReactComponent };